












































	import { Vue, Component, Provide, Watch } from 'vue-property-decorator';
	import Dialog from '../../component-dev/dialog';
	import Backdrop from '../../component-dev/backdrop';
	import PopupShare from './component/popupShare';
	import lottie from 'lottie-web';
    import Trophy from './data.json';
    import EventProxy from 'eventproxy';
	// import Shake from 'shake.js';
	const Shake = require('shake.js');
	import { makeStatReportParam } from '../../service/stat/Directive';
	import { stat } from '../../service/stat';
    import { IS_ZXG, IS_MQQ } from '../../service/platform/environment';
import { debounce } from 'lodash-es';
  declare global {
    interface Window {
      DeviceMotionEvent: any
    }
  }
  //let Shake = require('shake.js');
  @Component({
    components: {
      Backdrop,
      Dialog,
      PopupShare,
    }
  })
  export default class Page extends Vue  {
    anim: any;
    flag: Boolean = false;
    nickname: string;
    startDrawAfterAnimation: any;
    isShakeEventInstalled: Boolean = false;
      
    mounted () {
      let image = [
        require('./images/animation/img_0.png'),
        require('./images/animation/img_1.png'),
        require('./images/animation/img_2.png'),
        require('./images/animation/img_3.png'),
        require('./images/animation/img_4.png'),
        require('./images/animation/img_5.png'),
        require('./images/animation/img_6.png'),
        require('./images/animation/img_7.png'),
        require('./images/animation/img_8.png'),
        require('./images/animation/img_9.png'),
        require('./images/animation/img_10.png'),
        require('./images/animation/img_12.png'),
        require('./images/animation/img_13.png'),
        require('./images/animation/img_14.png'),
        require('./images/animation/img_15.png'),
        require('./images/animation/img_16.png'),
        require('./images/my_label.png'),
      ];
      let self = this;
      let $div = document.createElement('div');   // append一个新节点
      $div.className = 'animationWrap layout layout-column flex';
      (this.$refs.animation as any).appendChild($div);
      //document.body.appendChild($div);
      window.oo = this.anim = lottie.loadAnimation({
          container: $div,
          renderer: 'canvas',
          loop: false,
          autoplay: false,
          animationData: Trophy,//动画json
        }
      );
      // 播放抽签后置动画
      this.startDrawAfterAnimation = EventProxy.create('DrawBeforeAnimationDidFinish', 'ShakeEventDidOccur', () => {
          this.anim.play();
          this.anim.setSpeed(1.3);
          this.anim.addEventListener('complete', () => {
              self.showLabelDialog();
              this.anim.destroy();
          });
      });
        // self.showLabelDialog();
        this.anim.setSpeed(1.4);
        this.anim.play();
        let shakeEventInstaller = () => {
            // 从3帧开始监听晃动事件，视情况调整具体时间
            console.log(`frame #${Math.floor(this.anim.currentFrame)}`);
            if (Math.floor(this.anim.currentFrame) > 3) {
                this.listenPhoneShake();
            }
            // 50帧时停止动画
            if (Math.floor(this.anim.currentFrame) > 50) {
                this.anim.removeEventListener("enterFrame");
                this.anim.pause();
                this.startDrawAfterAnimation.emit('DrawBeforeAnimationDidFinish');
            }
        };
        this.anim.addEventListener("enterFrame", shakeEventInstaller);
    }
    // 展示抽签弹窗z
    showLabelDialog() {
      const PopupShareComp = PopupShare as any;
      const unmount = Backdrop.mount({
        source: 'page',
        target: 'root',
        applyFilterFor: '#root',
        content: (
          <div class="backdrop-bg layout-column layout-align-center-center">
              <div class="backdrop-bg-mask layout-column layout-align-center-center">
          <PopupShareComp nickname={this.nickname} onClick={() => unmount()} onHide={() => {}}></PopupShareComp>
              </div>
                </div>
        )
      }, this.$createElement);
    }
    
    //监听摇一摇的动作,如果不支持摇一摇，则直接播放动画
    listenPhoneShake() {
      let self = this;
      if (this.isShakeEventInstalled) {
          return;
      }
      this.isShakeEventInstalled = true;
      //if (!window.DeviceMotionEvent) {  // 为了调试
      if (window.DeviceMotionEvent) {
        // 是否有摇动手机
        let myShakeEvent = new Shake({
            threshold: 3,  // 摇动阈值
        });
        
        myShakeEvent.start();
        console.log('shake event installed');
        window.addEventListener('shake', this.shakeEventDidOccur, false);
      } else {
        // this.anim.play();
        this.anim.goToAndPlay(100, true);
        this.anim.addEventListener('complete', () => {
          self.showLabelDialog();
        });
        }
    }


    // 手机摇晃后的操作
    shakeEventDidOccur() {
        window.removeEventListener('shake', this.shakeEventDidOccur, false);
        let self = this;
        // 去掉只能摇一次的限制
        // if (this.flag == false) {
            console.log('shake event did occur, is paused when shake event happen', this.anim.isPaused);
            this.startDrawAfterAnimation.emit('ShakeEventDidOccur');
        // }
        // this.flag = true;
        const currentPath = this.$route.path;
        if (IS_ZXG) {
            stat.sendClickStat(
                makeStatReportParam('19newyear.label.shake.zxg', currentPath),
                currentPath,
            );
        } else {
            stat.sendClickStat(
                makeStatReportParam('19newyear.label.shake', currentPath),
                currentPath,
            );
        }
    }
  }
